import { Box, Button, Grid, IconButton, TextField, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { UpdateApproverExpenseAction } from "../../../../../store/Finance/Expense/Action";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { getImageSignedUrl } from "../../../Base/helper/baseFunctions";
import { toast } from "react-toastify";

const ExpenseApprovedPopUp = ({ closeMode, editedRecord }) => {
  const initialState = {
    finance_approver_amount: null,
    finance_comment: "",
  };
  const dispatch = useDispatch();

  const [expenseData, setExpenseData] = useState(initialState);
  const [errors, setErrors] = useState({});
  const [actionType, setActionType] = useState("Approve");
  const { company_logo } = useSelector(state => state?.AncillaryReducer?.LetterHeadReducer);

  const validate = (fieldValues) => {
    let temp = { ...errors };
    if (actionType === "Approve") {
      if ("finance_approver_amount" in fieldValues) {
        temp.finance_approver_amount =
          fieldValues.finance_approver_amount === "" || fieldValues.finance_approver_amount === null
            ? "Approve Amount is required"
            : "";
      }
    }
    if (actionType === "Reject") {
      if ("finance_comment" in fieldValues)
        temp.finance_comment =
          fieldValues.finance_comment?.trim() === ""
            ? "Reason is required for rejection"
            : "";
    }
    setErrors({ ...temp });

    return Object.values(temp).every((x) => x === "");
  };
  const handleInput = (event) => {
    const { name, value } = event.target;
    setExpenseData((prev) => ({
      ...prev,
      [name]: value,
    }));
    Object.values?.(errors)?.find((res) => res !== "")?.length > 0 &&
      validate({
        ...expenseData,
        [name]: value,
      });
  };

  const handleSubmit = async () => {
    if (!validate(expenseData)) return;
    if (editedRecord?.employee_expenses_pk && actionType === "Approve") {
      dispatch(
        UpdateApproverExpenseAction({
          employee_expenses_pk: expenseData?.employee_expenses_pk,
          finance_approver_amount: expenseData?.finance_approver_amount,
          finance_approver_status: "Approved",
          employee_status: "Approved",
          employeeName: expenseData?.employee_name,
          employeeEmail: expenseData?.employee_email, 
          claimedAmount: expenseData?.employee_amount,
          category: expenseData?.expense_name,
          subCategory: expenseData?.sub_expense_type_name,
          company_logo
        })
      );
    } else if (actionType === "Reject") {
      dispatch(
        UpdateApproverExpenseAction({
          employee_expenses_pk: editedRecord?.employee_expenses_pk,
          finance_approver_amount: null,
          finance_approver_status: "Rejected",
          employee_status: "Rejected",
          approver_comment: expenseData?.finance_comment,
          employeeName: expenseData?.employee_name,
          employeeEmail: expenseData?.employee_email,
          claimedAmount: expenseData?.employee_amount,
          category: expenseData?.expense_name,
          subCategory: expenseData?.sub_expense_type_name,
          company_logo
        })
      );
    }
    closeMode();
  };

  useEffect(() => {
    setExpenseData({
     ...initialState,
      ...editedRecord,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editedRecord]);

    const handleView = async (rowData) => {
      try {
        const url = await getImageSignedUrl(rowData);
        if (rowData.endsWith(".doc") || rowData.endsWith(".docx")) {
        window.open(
          `https://docs.google.com/viewer?url=${encodeURIComponent(
            url
          )}&embedded=true`,
          "_blank"
        );
      } else {
        window.open(url, "_blank");
      }
        return url;
      } catch (err) {
        toast.error(err);
      }
    };

    const handleActionTypeChange = (event, newValue) => {
      if (newValue) setActionType(newValue); setErrors({})
    };
  return (
    <>
    <Box sx={{ px: "0.75rem" }}>
      <Box
        sx={{
          px: 3,
          py: 2,
          mb: 2,
          borderRadius: 2,
          backgroundColor: "#f4f2f7",
          border: "1px solid #E0E0E0",
        }}
      >
        <Typography variant="h6" gutterBottom>
          Expense Summary
        </Typography>

        <Grid container spacing={1.5}>
          <Grid item xs={6}>
            <Typography variant="body2" color="textSecondary">
              Employee Name
            </Typography>
            <Typography fontWeight={500}>
              {expenseData?.employee_name || "-"}
            </Typography>
          </Grid>

          <Grid item xs={6}>
            <Typography variant="body2" color="textSecondary">
              Category
            </Typography>
            <Typography fontWeight={500}>
              {expenseData?.expense_name || "-"}
            </Typography>
          </Grid>

          <Grid item xs={6}>
            <Typography variant="body2" color="textSecondary">
              Subcategory
            </Typography>
            <Typography fontWeight={500}>
              {expenseData?.sub_expense_type_name || "-"}
            </Typography>
          </Grid>

          <Grid item xs={6}>
            <Typography variant="body2" color="textSecondary">
              Date
            </Typography>
            <Typography fontWeight={500}>
              {expenseData?.entry_date || "-"}
            </Typography>
          </Grid>

          <Grid item xs={6}>
            <Typography variant="body2" color="textSecondary">
              Claimed Amount
            </Typography>
            <Typography fontWeight={500}>
              ₹{expenseData?.employee_amount || "0"}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body2" color="textSecondary">
              Preview Proof
            </Typography>
            {expenseData.proof ? (
              <Box  sx={{paddingLeft: "15px", marginTop: "-5px"}}>
                <IconButton onClick={() => handleView(expenseData?.proof)}>
                  <VisibilityIcon />
                </IconButton>
              </Box>
              ) : (
                "N/A"
              )}
          </Grid>
        </Grid>
      </Box>

    </Box>
      <Grid container>
        <Grid item xs={12} md={12} sx={{ px: "0.75rem", mb: 1 }}>
          <ToggleButtonGroup
            value={actionType}
            exclusive
            onChange={handleActionTypeChange}
            aria-label="approve or reject"
            size="large"
            color="primary"
            fullWidth
            sx={{ width: "100%", height: 40 }}
          >
            <ToggleButton value="Approve" aria-label="approve" sx={{ flex: 1, height: 40 }}>
              Approve
            </ToggleButton>
            <ToggleButton value="Reject" aria-label="reject" sx={{ flex: 1, height: 40, 
                color: actionType === "Reject" ? "white" : "error.main",
                border: "1px solid",
                borderColor: actionType === "Reject" ? "#ff7f7f" : "rgba(0,0,0,0.12)",
                "&.Mui-selected": {
                  bgcolor: "#ff7f7f",
                  color: "white",
                },
                "&:hover": {
                  bgcolor: "#ff7f7f",
                  color: "white",
                },
                '&.Mui-selected:hover': {
                backgroundColor: "#ff7f7f",
              }
            }}>
              Reject
            </ToggleButton>
          </ToggleButtonGroup>
        </Grid>
        <Grid item xs={12} md={12} sx={{ padding: "0.75rem" }}>
          {actionType === "Approve" && (
            <TextField
              fullWidth
              name="finance_approver_amount"
              label="Approve Amount"
              type="number"
              size="small"
              required
              value={expenseData?.finance_approver_amount}
              onChange={handleInput}
              {...(errors.finance_approver_amount && {
                error: true,
                helperText: errors.finance_approver_amount,
              })}
            />
          )}
          {actionType === "Reject" && (
            <TextField
              fullWidth
              name="finance_comment"
              label="Reason"
              size="small"
              required
              multiline
              minRows={3}
              value={expenseData?.finance_comment}
              onChange={handleInput}
              error={Boolean(errors.finance_comment)}
              helperText={errors.finance_comment}
            />
          )}
        </Grid>
      </Grid>
      <Box sx={{ display: "flex", justifyContent: "space-between", m: 1.5 }}>
        <Button
          className="mpl-primary-btn"
          variant="contained"
          size="medium"
          onClick={closeMode}
        >
          Cancel
        </Button>
        <Button
          className="mpl-primary-btn"
          variant="contained"
          size="medium"
          onClick={handleSubmit}
        >
          {actionType}
        </Button>
      </Box>
    </>
  );
};

export default ExpenseApprovedPopUp;
